import type { AnySupportedLanguage } from '@app/lang/types'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface SettingsState {
  theme: 'light' | 'dark'
  language: AnySupportedLanguage
}

const initialState: SettingsState = {
  theme: 'light',
  language: 'de',
}

export const SettingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    changeTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload
    },
    updateLanguage: (state, action: PayloadAction<AnySupportedLanguage>) => {
      state.language = action.payload
    },
  },
})

export const { changeTheme, updateLanguage } = SettingsSlice.actions

export default SettingsSlice.reducer
